import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = {
  class: "c-section -white || o-padding -big-top -huge-bottom",
  "data-scroll-section": ""
}
const _hoisted_2 = { class: "o-container" }
const _hoisted_3 = { class: "o-grid -col-4 -col-8@from-medium -gutters c-sticky_section" }
const _hoisted_4 = { class: "o-grid_item u-gc-1/4@from-medium" }
const _hoisted_5 = {
  class: "o-padding -medium-bottom -no-padding-bottom@from-medium c-sticky_element",
  "data-scroll": "",
  "data-scroll-sticky": "",
  "data-scroll-target": "#target",
  "data-scroll-position": "top"
}
const _hoisted_6 = { class: "c-figure -lazy-load -no-bg || c-text-illu_figure -form || o-padding -medium-bottom -no-padding-bottom@from-medium" }
const _hoisted_7 = { class: "c-figure_inner" }
const _hoisted_8 = ["src", "data-src", "width", "height"]
const _hoisted_9 = { class: "o-grid_item u-gc-5/9@from-medium" }
const _hoisted_10 = { class: "c-heading-decorative -editorial -size-smaller || o-margin -tiny-bottom" }
const _hoisted_11 = { class: "o-margin -large-bottom" }
const _hoisted_12 = { class: "c-form_title" }
const _hoisted_13 = { class: "c-form_controls" }
const _hoisted_14 = { class: "c-form_button_group" }
const _hoisted_15 = {
  class: "c-form_button_back",
  type: "button",
  disabled: ""
}
const _hoisted_16 = { class: "c-form_progress" }
const _hoisted_17 = { class: "c-form_title" }
const _hoisted_18 = { class: "c-form_controls" }
const _hoisted_19 = { class: "c-form_button_group" }
const _hoisted_20 = { class: "c-form_progress" }
const _hoisted_21 = { class: "c-form_title" }
const _hoisted_22 = { class: "c-form_item" }
const _hoisted_23 = {
  for: "Name",
  class: "c-form_label -required"
}
const _hoisted_24 = { class: "c-form_item_group -group-1/2" }
const _hoisted_25 = { class: "c-form_item_group -group-1/2" }
const _hoisted_26 = { class: "c-form_item" }
const _hoisted_27 = { class: "c-form_item" }
const _hoisted_28 = { class: "c-form_item" }
const _hoisted_29 = { class: "c-form_item" }
const _hoisted_30 = { class: "c-form_item" }
const _hoisted_31 = { class: "c-form_controls" }
const _hoisted_32 = { class: "c-form_button_group" }
const _hoisted_33 = { class: "c-form_progress" }
const _hoisted_34 = { class: "c-form_title" }
const _hoisted_35 = { class: "c-form_item" }
const _hoisted_36 = { class: "c-form_controls" }
const _hoisted_37 = { class: "c-form_button_group" }
const _hoisted_38 = {
  class: "c-form_button_submit",
  type: "submit"
}
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  key: 1,
  class: "c-form_success"
}
const _hoisted_41 = { class: "c-form_title" }
const _hoisted_42 = { class: "c-form_success_title" }
const _hoisted_43 = { class: "c-form_success_text" }
const _hoisted_44 = {
  key: 0,
  "data-scroll-section": ""
}
const _hoisted_45 = { class: "c-form_stepper -relative" }
const _hoisted_46 = {
  key: 1,
  class: "c-form_stepper"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RadioInput = _resolveComponent("RadioInput")
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")
  const _component_TextInput = _resolveComponent("TextInput")
  const _component_EmailInput = _resolveComponent("EmailInput")
  const _component_PhoneInput = _resolveComponent("PhoneInput")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_Image = _resolveComponent("Image")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[17] || (_cache[17] = _createElementVNode("div", {
            id: "target",
            class: "c-sticky_target"
          }, null, -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("figure", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "c-figure_image",
                    src: 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 ' + $data.image.width + ' ' + $data.image.height + '\'%3E%3C/svg%3E',
                    "data-src": $data.image.url,
                    alt: "",
                    width: $data.image.width,
                    height: $data.image.height,
                    "data-scroll": "",
                    "data-scroll-call": "lazyLoad, Scroll"
                  }, null, 8 /* PROPS */, _hoisted_8)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            ($data.submited != true)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  ref: "form$",
                  onSubmit: _cache[15] || (_cache[15] = _withModifiers((...args) => ($options.checkForm && $options.checkForm(...args)), ["prevent"])),
                  class: _normalizeClass(["c-form", { 'is-form-invalid': $data.formInvalid, 'is-loading': $data.loading, 'is-submited': $data.submited }]),
                  novalidate: "true"
                }, [
                  ($data.step == 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx._t("Let’s Get Started")), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx._t("Accept credit cards in your store, on the go, or online.")), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx._t("Credit cards")), 1 /* TEXT */),
                        _createVNode(_component_RadioInput, {
                          modelValue: $data.form.Do_you_accept_credit_cards_now,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.form.Do_you_accept_credit_cards_now) = $event)),
                          id: "Do_you_accept_credit_cards_now",
                          name: "Do_you_accept_credit_cards_now",
                          labelText: _ctx._t('Do you accept credit cards now?'),
                          choices: [
                                { id: 'creditCardsYes', value: 'YES', label: _ctx._t('Yes') },
                                { id: 'creditCardsNo', value: 'NO', label: _ctx._t('No') }
                            ],
                          required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "labelText", "choices"]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx._t("Back")), 1 /* TEXT */),
                            _createElementVNode("button", {
                              class: "c-form_button_next",
                              type: "button",
                              onClick: _cache[1] || (_cache[1] = $event => ($options.nextStep(2)))
                            }, _toDisplayString(_ctx._t("Next")), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx._t("Step") + " 1 " + _ctx._t("of") + " " + $data.steps.length), 1 /* TEXT */)
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  ($data.step == 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx._t("Processing method")), 1 /* TEXT */),
                        _createVNode(_component_CheckboxInput, {
                          modelValue: $data.form.Processing_Method,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.form.Processing_Method) = $event)),
                          id: "Processing_Method",
                          name: "Processing_Method",
                          labelText: _ctx._t('Choose your processing method'),
                          choices: [
                                { id: 'processingMethodInPerson', value: 'Counter top Credit Card Terminal', label: _ctx._t('Counter top Credit Card Terminal') },
                                { id: 'processingMethodOnline', value: 'Wireless Credit Card Terminal', label: _ctx._t('Wireless Credit Card Terminal') },
                                { id: 'processingMethodBoth', value: 'Online Processing', label: _ctx._t('Online Processing') }
                            ],
                          required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "labelText", "choices"]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("button", {
                              class: "c-form_button_back",
                              type: "button",
                              onClick: _cache[3] || (_cache[3] = $event => ($options.previousStep(1)))
                            }, _toDisplayString(_ctx._t("Back")), 1 /* TEXT */),
                            _createElementVNode("button", {
                              class: "c-form_button_next",
                              type: "button",
                              onClick: _cache[4] || (_cache[4] = $event => ($options.nextStep(3)))
                            }, _toDisplayString(_ctx._t("Next")), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx._t("Step") + " 2 " + _ctx._t("of") + " " + $data.steps.length), 1 /* TEXT */)
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  ($data.step == 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx._t("Tell Us About You")), 1 /* TEXT */),
                        _createCommentVNode(" Name "),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx._t('Name')), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_TextInput, {
                              modelValue: $data.form.First_Name,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.form.First_Name) = $event)),
                              labelText: _ctx._t('First name'),
                              id: "FirstName",
                              name: "FirstName",
                              required: "",
                              labelUnder: ""
                            }, null, 8 /* PROPS */, ["modelValue", "labelText"])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_TextInput, {
                              modelValue: $data.form.Last_Name,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.form.Last_Name) = $event)),
                              labelText: _ctx._t('Last name'),
                              id: "LastName",
                              name: "LastName",
                              required: "",
                              labelUnder: ""
                            }, null, 8 /* PROPS */, ["modelValue", "labelText"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_EmailInput, {
                            modelValue: $data.form.Email,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.form.Email) = $event)),
                            id: "Email",
                            name: "Email",
                            required: "",
                            labelText: _ctx._t('Email')
                          }, null, 8 /* PROPS */, ["modelValue", "labelText"])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_TextInput, {
                            modelValue: $data.form.Temp_Company,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.form.Temp_Company) = $event)),
                            id: "CompanyName",
                            name: "CompanyName",
                            required: "",
                            labelText: _ctx._t('Company Name')
                          }, null, 8 /* PROPS */, ["modelValue", "labelText"])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_PhoneInput, {
                            modelValue: $data.form.Phone,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.form.Phone) = $event)),
                            id: "Phone",
                            name: "Phone",
                            required: "",
                            labelText: _ctx._t('Phone')
                          }, null, 8 /* PROPS */, ["modelValue", "labelText"])
                        ]),
                        _createCommentVNode(" Country "),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_SelectInput, {
                            modelValue: $data.form.Business_Location,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.form.Business_Location) = $event)),
                            id: "Country",
                            name: "Business_Location",
                            required: "true",
                            labelText: _ctx._t('Company location'),
                            options: [
                                    { value: 'Canada', text: 'Canada' },
                                    { value: 'USA', text: _ctx._t('USA') },
                                ]
                          }, null, 8 /* PROPS */, ["modelValue", "labelText", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_SelectInput, {
                            modelValue: $data.form.Current_Credit_Volume,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.form.Current_Credit_Volume) = $event)),
                            id: "MonthlyVolume",
                            name: "MonthlyVolume",
                            required: "",
                            labelText: _ctx._t('Monthly Volume'),
                            options: [
                                    { value: 49000, text: _ctx._t('Less than $50 000') },
                                    { value: 50000, text: _ctx._t('$50 000 to $200 000') },
                                    { value: 200001, text: _ctx._t('$200 001 to $500 000') },
                                    { value: 500001, text: _ctx._t('$500 001 to $1 000 000') },
                                    { value: 1000001, text: _ctx._t('$1 000 001 to $2 500 000') },
                                    { value: 2500001, text: _ctx._t('$2 500 001 to $5 000 000') },
                                    { value: 5000001, text: _ctx._t('$5 000 001 +') }
                                ]
                          }, null, 8 /* PROPS */, ["modelValue", "labelText", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("button", {
                              class: "c-form_button_back",
                              type: "button",
                              onClick: _cache[12] || (_cache[12] = $event => ($options.previousStep(2)))
                            }, _toDisplayString(_ctx._t("Back")), 1 /* TEXT */),
                            _createElementVNode("button", {
                              class: "c-form_button_next",
                              type: "button",
                              onClick: _cache[13] || (_cache[13] = $event => ($options.nextStep(4)))
                            }, _toDisplayString(_ctx._t("Next")), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx._t("Step") + " 3 " + _ctx._t("of") + " " + $data.steps.length), 1 /* TEXT */)
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  ($data.step == 4)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx._t("How soon do you need to get started?" )), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_SelectInput, {
                            modelValue: $data.form.How_soon_do_you_need_to_get_started,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.form.How_soon_do_you_need_to_get_started) = $event)),
                            id: "How_soon_do_you_need_to_get_started",
                            name: "How_soon_do_you_need_to_get_started",
                            required: "",
                            labelText: _ctx._t('How soon do you need to get started?'),
                            options: [
                                    { value: 'Less than a week', text: _ctx._t('Less than a week') },
                                    { value: '1-2 Weeks', text: _ctx._t('1-2 Weeks') },
                                    { value: '3-6 Weeks', text: _ctx._t('3-6 Weeks') },
                                    { value: '7+ Weeks', text: _ctx._t('7+ Weeks') }
                                ]
                          }, null, 8 /* PROPS */, ["modelValue", "labelText", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("button", _hoisted_38, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "c-form_button_spinner" }, null, -1 /* HOISTED */)),
                              _createTextVNode(" " + _toDisplayString(_ctx._t("Get Solution")), 1 /* TEXT */)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "c-form_legal",
                          innerHTML: $props.completion_text
                        }, null, 8 /* PROPS */, _hoisted_39)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], 34 /* CLASS, NEED_HYDRATION */))
              : _createCommentVNode("v-if", true),
            ($data.submited==true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx._t("Thank you")), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx._t("Your information has been submitted")), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx._t("We will be in touch shortly")), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    ($data.submited!=true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.steps, (s) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["c-form_stepper_step", { 'is-complete': s.complete, 'is-active': s.id == $data.step }])
              }, [
                _createVNode(_component_Image, { id: "complete" }),
                _createElementVNode("span", null, _toDisplayString(s.name), 1 /* TEXT */)
              ], 2 /* CLASS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($data.submited!=true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.steps, (s) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["c-form_stepper_step", { 'is-complete': s.complete, 'is-active': s.id == $data.step }])
            }, [
              _createVNode(_component_Image, { id: "complete" }),
              _createElementVNode("span", null, _toDisplayString(s.name), 1 /* TEXT */)
            ], 2 /* CLASS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}